import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(customParseFormat);

const FORMAT_BY_LOCALE = {
  en: "MM/DD/YYYY h:mm A",
  es: "DD/MM/YYYY HH:mm",
  uk: "DD.MM.YYYY HH:mm",
};

export function getLocalDateFormat(locale) {
  return FORMAT_BY_LOCALE[locale] ?? FORMAT_BY_LOCALE.en;
}

/**
 * Parses a PayPro UTC date string into a dayjs object (UTC mode).
 * Use for comparisons (isBefore/isAfter) — these are mode-agnostic.
 * For display, use formatUTCToLocal which handles UTC → local conversion.
 * @param {string} utcDate - Date in "M/D/YYYY h:mm A" format in UTC (PayPro IPN)
 * @returns {dayjs.Dayjs|null} - dayjs object, or null if input is empty/invalid
 */
export function parseUTCDate(utcDate) {
  if (!utcDate) return null;
  const parsed = dayjs.utc(utcDate, "M/D/YYYY h:mm A");
  return parsed.isValid() ? parsed : null;
}

/**
 * Converts a UTC date to the user's local time, formatted for display.
 * @param {string} utcDate - Date in "M/D/YYYY h:mm A" format in UTC (PayPro IPN)
 * @param {string} format - Output format. Use getLocalDateFormat(locale) for locale-aware output.
 * @returns {string} - Formatted local-time string, or "" if input is empty/invalid
 */
export function formatUTCToLocal(utcDate, format = "MM/DD/YYYY h:mm A") {
  const parsed = parseUTCDate(utcDate);
  return parsed ? parsed.local().format(format) : "";
}
